<template>
    <div>{{ $i18n('errors.generic.message') }}</div>
</template>

<!--
  This dialog covers the shared login and MFA authentication errors. `LoginView`, `MfaVerifyView`
  and `MfaSetupView` each show it when auth-service rejects a request for a missing parameter, an
  unknown client, or an invalid redirect URI (CM-1823); `LoginView` also shows it for
  `error=bad_state`. Any change here lands on all three views.

  It deliberately names no host. It used to name `config.adminEntryUrl` unconditionally, which told
  a user who started elsewhere to go to admin and read as an origin restriction rather than the
  parameter problem it actually is. Naming the host from the flow's own `redirect_uri` instead fixed
  the misdirection but reflected an attacker-influenced query value into a link on the auth origin,
  so a crafted `error=bad_state` URL rendered an attacker's host as a link on the real login page.
  Omitting the host removes both problems: there is nothing to reflect, and the message no longer
  implies the user is in the wrong place.

  So: no `redirect_uri` read here, and no anchor. Reintroducing either brings the phishing vector
  back.
-->
